/*
 * This file is generated by generate_bundler_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {PricesFlatsGeneralView} from "../../report/price/views/PricesFlatsGeneralView";
import {PricesFlatsView} from "../../report/price/views/PricesFlatsView";
const route = [
    {bundlerEntry: "reports", path: rpAppPath.prices.flats.base, component: PricesFlatsGeneralView},
    {bundlerEntry: "reports", path: rpAppPath.prices.flats.city, component: PricesFlatsView}
];

(function () {
    rpClient(route);
})();
/*
 * This file is generated by generate_bundler_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {PricesFlatsGeneralView} from "../../report/price/views/PricesFlatsGeneralView";
import {PricesFlatsView} from "../../report/price/views/PricesFlatsView";
const route = [
    {bundlerEntry: "reports", path: rpAppPath.prices.flats.base, component: PricesFlatsGeneralView},
    {bundlerEntry: "reports", path: rpAppPath.prices.flats.city, component: PricesFlatsView}
];

(function () {
    rpClient(route);
})();
